/* Enhances server-rendered product links. Every assortment remains visible without JavaScript. */
(() => {
  function init(root) {
    if (root.dataset.editsReady) return;
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    if (!tabs.length || tabs.length !== panels.length) return;
    function select(index, focus = false) {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
      });
      if (focus) tabs[index].focus();
    }
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i));
      tab.addEventListener('keydown', event => {
        const rtl = getComputedStyle(root).direction === 'rtl';
        let index;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = tabs.length - 1;
        if (event.key === 'ArrowRight') index = (i + (rtl ? -1 : 1) + tabs.length) % tabs.length;
        if (event.key === 'ArrowLeft') index = (i + (rtl ? 1 : -1) + tabs.length) % tabs.length;
        if (index === undefined) return;
        event.preventDefault();
        select(index, true);
      });
    });
    root.dataset.editsReady = 'true';
    select(0);
    root.querySelector('[role="tablist"]').hidden = false;
  }
  const initAll = scope => scope.querySelectorAll('[data-hatchill-home-edits]').forEach(init);
  initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  const hero = document.querySelector('.hz-hero');
  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      document.body.classList.toggle('hz-past-hero', !entries[0].isIntersecting);
    }, {rootMargin: '-80px 0px 0px', threshold: 0}).observe(hero);
  }
})();
